/**
 * SSF — Whole-card clickable (event delegation approach)
 * 
 * Au lieu d'injecter un overlay, on écoute les clics sur toute la carte.
 * Si le clic atterrit sur une zone "morte" (pas un lien/bouton existant),
 * on redirige vers l'URL du produit.
 */
(function() {
  'use strict';

  function getCardProductUrl(card) {
    const link = card.querySelector('.card__title a, .card-link, .js-prod-link');
    return link?.getAttribute('href') || null;
  }

  function isInteractiveElement(el, card) {
    // Remonte jusqu'à la carte pour vérifier si on a traversé une zone interactive
    let current = el;
    while (current && current !== card) {
      const tag = current.tagName;
      
      // Liens et boutons existants : on laisse faire
      if (tag === 'A' || tag === 'BUTTON') return true;
      
      // Inputs (swatches, checkboxes)
      if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA' || tag === 'LABEL') return true;
      
      // Quick-add, swatches, compare : laisser faire
      if (current.classList?.contains('card__quick-add')) return true;
      if (current.classList?.contains('card__swatches')) return true;
      if (current.classList?.contains('card__compare')) return true;
      if (current.classList?.contains('jdgm-widget')) return true;
      
      // Slider controls (image carousel sur card)
      if (current.classList?.contains('slider-nav')) return true;
      if (current.classList?.contains('slider-counter')) return true;
      
      current = current.parentElement;
    }
    return false;
  }

  document.addEventListener('click', (e) => {
    const card = e.target.closest('product-card.card--product');
    if (!card) return;
    
    // Ignorer si le clic est sur un élément interactif
    if (isInteractiveElement(e.target, card)) return;
    
    // Sinon, naviguer vers la page produit
    const url = getCardProductUrl(card);
    if (!url) return;
    
    // Si Cmd/Ctrl maintenu → ouvrir dans un nouvel onglet
    if (e.metaKey || e.ctrlKey) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  });

  // Visual feedback : cursor pointer sur toute la carte
  // (pour indiquer qu'elle est cliquable)
})();